// Location ids end up inside URL paths (e.g. shipment snapshot ids embed the
// destination id), so reserved URL characters break routing. Only enforced
// for new ids: some existing ids contain characters like apostrophes and must
// stay editable.
const URL_UNSAFE_CHARS = /[/?#%\\]/

const getLocationIdError = id => {
  if (id && URL_UNSAFE_CHARS.test(id)) {
    return `Invalid _id "${id}": location ids can not contain "/", "?", "#", "%" or "\\"`
  }
}

module.exports = getLocationIdError
